import tmhRequest from '@/config/tmhRequest'


export default {
    searchSummaryBeauticianPerformanceReportCount: function (data) {
        return tmhRequest({
            url: '/report/ispa/summarybeauticianperformancereport/searchsummarybeauticianperformancereportcount',
            method: 'post',
            data: data,
        })
    },
    searchSummaryBeauticianPerformanceReportByPage: function (data) {
        return tmhRequest({
            url: '/report/ispa/summarybeauticianperformancereport/searchsummarybeauticianperformancereportbypage',
            method: 'post',
            data: data,
        })
    },
    exportSummaryBeauticianPerformanceReport: function (data) {
        return tmhRequest({
            url: '/report/ispa/summarybeauticianperformancereport/exportsummarybeauticianperformancereport',
            method: 'post',
            responseType: 'blob',
            data: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/ispa/report/summarybeauticianperformancereport.js